// API Calls Utils
import { updateUserInfo, asyncChangePassword } from 'utils/api/profile';
// THUNK Wrappers for API Calls
import { updateFormDataWithValidation } from 'state/actions/formactionswrapper';

// -------------- ++++++++ -------------- START: THUNKS -------------- ++++++++ -------------- //

export const updateUserInfoWithValidation = (fields, updatedData, userUUID, onSuccess, onFail) => updateFormDataWithValidation('personalInformationForm', fields, updateUserInfo, updatedData, userUUID, onSuccess, onFail);


//Change Password Action(thunk)

export const changePassword = (fields, data) => updateFormDataWithValidation('changePasswordForm', fields, asyncChangePassword, data);

// -------------- ++++++++ -------------- END: THUNKS -------------- ++++++++ -------------- //




